import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";

export default function CardSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div {...useBlockProps.save()}>
      <div className="graphic-top bg-dark"></div>
      <div className="inner bg-dark">
        <InnerBlocks.Content />
      </div>
      <div className="graphic-bot bg-dark"></div>
    </div>
  );
}
